import { render, staticRenderFns } from "./new-printer.vue?vue&type=template&id=0d51a23d"
import script from "./new-printer.vue?vue&type=script&lang=js"
export * from "./new-printer.vue?vue&type=script&lang=js"
import style0 from "./new-printer.vue?vue&type=style&index=0&id=0d51a23d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports